import { render, staticRenderFns } from "./NotificationEmailVerifying.vue?vue&type=template&id=b5456e66&lang=pug&"
import script from "./NotificationEmailVerifying.vue?vue&type=script&lang=js&"
export * from "./NotificationEmailVerifying.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports